<template>
    <p>Settings</p>
</template>
<script>
export default {
    
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/settings-page.vue